// import React, { useState, useEffect } from 'react';
// import styles from './UserManagement.module.css';

// const UserFormSlider = ({
//     show,
//     mode,
//     user,
//     roles,
//     studies,
//     sites,
//     onClose,
//     onSubmit
// }) => {
//     const [formData, setFormData] = useState({
//         full_name: '',
//         email_address: '',
//         contact_number: '',
//         role_id: '',
//         study_id: '',
//         site_id: '',
//         assigned_sites: [],
//         status: true
//     });

//     const [siteAssignments, setSiteAssignments] = useState([]);
//     const [showAddAssignmentForm, setShowAddAssignmentForm] = useState(false);
//     const [editingIndex, setEditingIndex] = useState(null);
//     const [newAssignment, setNewAssignment] = useState({
//         study_id: '',
//         study_number: '',
//         study_name: '',
//         site_id: '',
//         site_code: '',
//         site_name: '',
//         max_subjects: '20',
//         currency: 'USD',
//         service_fee: '1500.00',
//         consent_template: 'Template -1'
//     });

//     useEffect(() => {
//         if (mode === 'edit' && user) {
//             setFormData({
//                 full_name: user.full_name,
//                 email_address: user.email_address,
//                 contact_number: user.contact_number || '',
//                 role_id: Number(user.role_id),
//                 study_id: Number(user.study_id),
//                 site_id: '',
//                 assigned_sites: user.assigned_sites || [],
//                 status: user.status === 'Active'
//             });
//             setSiteAssignments(user.assigned_sites || []);
//         } else {
//             setFormData({
//                 full_name: '',
//                 email_address: '',
//                 contact_number: '',
//                 role_id: '',
//                 study_id: '',
//                 site_id: '',
//                 assigned_sites: [],
//                 status: true
//             });
//             setSiteAssignments([]);
//         }
//         setShowAddAssignmentForm(false);
//     }, [mode, user, show]);

//     const handleAddSite = () => {
//         setShowAddAssignmentForm(true);
//         setEditingIndex(null);
//         setNewAssignment({
//             study_id: '',
//             study_number: '',
//             study_name: '',
//             site_id: '',
//             site_code: '',
//             site_name: '',
//             max_subjects: '20',
//             currency: 'USD',
//             service_fee: '1500.00',
//             consent_template: 'Template -1'
//         });
//     };

//     const handleEditSite = (index) => {
//         setShowAddAssignmentForm(true);
//         setEditingIndex(index);
//         setNewAssignment({ ...siteAssignments[index] });
//     };

//     const handleRemoveSite = (index) => {
//         const newAssignments = siteAssignments.filter((_, i) => i !== index);
//         setSiteAssignments(newAssignments);
//     };

//     const handleAssignmentChange = (field, value) => {
//         setNewAssignment(prev => ({ ...prev, [field]: value }));

//         if (field === 'site_id') {
//             const selectedSite = sites.find(site => site.site_id === value);
//             if (selectedSite) {
//                 setNewAssignment(prev => ({
//                     ...prev,
//                     site_code: selectedSite.site_code,
//                     site_name: selectedSite.site_name
//                 }));
//             }
//         }

//         if (field === 'study_id') {
//             const selectedStudy = studies.find(study => study.study_id === value);
//             if (selectedStudy) {
//                 setNewAssignment(prev => ({
//                     ...prev,
//                     study_number: selectedStudy.study_number,
//                     study_name: selectedStudy.study_title
//                 }));
//             }
//         }
//     };

//     const handleSaveAssignment = () => {
//         if (newAssignment.study_id && newAssignment.site_id) {
//             if (editingIndex !== null) {
//                 const updatedAssignments = [...siteAssignments];
//                 updatedAssignments[editingIndex] = { ...newAssignment };
//                 setSiteAssignments(updatedAssignments);
//             } else {
//                 setSiteAssignments([...siteAssignments, { ...newAssignment }]);
//             }
//             setShowAddAssignmentForm(false);
//             setEditingIndex(null);
//             setNewAssignment({
//                 study_id: '',
//                 study_number: '',
//                 study_name: '',
//                 site_id: '',
//                 site_code: '',
//                 site_name: '',
//                 max_subjects: '20',
//                 currency: 'USD',
//                 service_fee: '1500.00',
//                 consent_template: 'Template -1'
//             });
//         }
//     };

//     const handleCancelAssignment = () => {
//         setShowAddAssignmentForm(false);
//         setEditingIndex(null);
//         setNewAssignment({
//             study_id: '',
//             study_number: '',
//             study_name: '',
//             site_id: '',
//             site_code: '',
//             site_name: '',
//             max_subjects: '20',
//             currency: 'USD',
//             service_fee: '1500.00',
//             consent_template: 'Template -1'
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const submitData = {
//             ...formData,
//             assigned_sites: siteAssignments,
//             status: formData.status ? 'Active' : 'Inactive'
//         };

//         const result = mode === 'edit'
//             ? await onSubmit(user.user_id, submitData)
//             : await onSubmit(submitData);

//         if (result.success) {
//             onClose();
//         }
//     };

//     if (!show) return null;

//     const selectedRole = roles.find(role => String(role.role_id) === String(formData.role_id));
//     const isPrincipalInvestigator = selectedRole && (
//         selectedRole.role_name === 'Principal Investigator' ||
//         String(selectedRole.role_id) === '2'
//     );

//     return (
//         <>
//             <div className={styles.sliderOverlay} onClick={onClose}></div>
//             <div className={`${styles.slider} ${show ? styles.sliderOpen : ''}`}>
//                 <div className={styles.sliderHeader}>
//                     <h2 className={styles.sliderTitle}>{mode === 'edit' ? 'Edit User' : 'Create New User'}</h2>
//                     <button className={styles.sliderClose} onClick={onClose}>
//                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <line x1="18" y1="6" x2="6" y2="18" />
//                             <line x1="6" y1="6" x2="18" y2="18" />
//                         </svg>
//                     </button>
//                 </div>
//                 <form onSubmit={handleSubmit}>
//                     <div className={styles.sliderBody}>
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Full Name *</label>
//                             <input
//                                 type="text"
//                                 className={styles.input}
//                                 required
//                                 value={formData.full_name}
//                                 onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
//                                 placeholder="Enter full name"
//                             />
//                         </div>
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Email Address *</label>
//                             <input
//                                 type="email"
//                                 className={styles.input}
//                                 required
//                                 value={formData.email_address}
//                                 onChange={(e) => setFormData({ ...formData, email_address: e.target.value })}
//                                 placeholder="user@example.com"
//                             />
//                         </div>
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Contact Number *</label>
//                             <input
//                                 type="text"
//                                 className={styles.input}
//                                 required
//                                 value={formData.contact_number}
//                                 onChange={(e) => setFormData({ ...formData, contact_number: e.target.value })}
//                                 placeholder="+1234567890"
//                             />
//                         </div>
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Role *</label>
//                             <select
//                                 className={styles.input}
//                                 required
//                                 value={formData.role_id}
//                                 onChange={(e) => setFormData({ ...formData, role_id: e.target.value })}
//                             >
//                                 <option value="">Select Role</option>
//                                 {roles.map((role) => (
//                                     <option key={role.role_id} value={role.role_id}>{role.role_name}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {isPrincipalInvestigator && (
//                             <div className={styles.siteAssignmentsSection}>
//                                 <label className={styles.label}>Study & Site Assignments</label>

//                                 {!showAddAssignmentForm && (
//                                     <button
//                                         type="button"
//                                         className={styles.addAssignmentLink}
//                                         onClick={handleAddSite}
//                                     >
//                                         <span className={styles.addIcon}>
//                                             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                 <circle cx="12" cy="12" r="10" />
//                                                 <line x1="12" y1="8" x2="12" y2="16" />
//                                                 <line x1="8" y1="12" x2="16" y2="12" />
//                                             </svg>
//                                         </span>
//                                         Add a site assignment
//                                     </button>
//                                 )}

//                                 {showAddAssignmentForm && (
//                                     <div className={styles.assignmentForm}>
//                                         <div className={styles.formGroup}>
//                                             <label className={styles.formLabel}>Study *</label>
//                                             <select
//                                                 className={styles.formInput}
//                                                 value={newAssignment.study_id}
//                                                 onChange={(e) => handleAssignmentChange('study_id', Number(e.target.value))}
//                                                 required
//                                             >
//                                                 <option value="">Select Study</option>
//                                                 {studies.map((study) => (
//                                                     <option key={study.study_id} value={study.study_id}>
//                                                         {study.study_number} - {study.study_title}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>

//                                         <div className={styles.formGroup}>
//                                             <label className={styles.formLabel}>Site *</label>
//                                             <select
//                                                 className={styles.formInput}
//                                                 value={newAssignment.site_id}
//                                                 onChange={(e) => handleAssignmentChange('site_id', Number(e.target.value))}
//                                                 required
//                                             >
//                                                 <option value="">Select Site</option>
//                                                 {sites.map((site) => (
//                                                     <option key={site.site_id} value={site.site_id}>
//                                                         {site.site_code} - {site.site_name}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>

//                                         <div className={styles.formGroup}>
//                                             <label className={styles.formLabel}>Max. Subjects</label>
//                                             <select
//                                                 className={styles.formInput}
//                                                 value={newAssignment.max_subjects}
//                                                 onChange={(e) => handleAssignmentChange('max_subjects', Number(e.target.value))}
//                                             >
//                                                 <option value="20">20</option>
//                                                 <option value="50">50</option>
//                                                 <option value="100">100</option>
//                                             </select>
//                                         </div>

//                                         <div className={styles.formGroup}>
//                                             <label className={styles.formLabel}>Currency</label>
//                                             <select
//                                                 className={styles.formInput}
//                                                 value={newAssignment.currency}
//                                                 onChange={(e) => handleAssignmentChange('currency', e.target.value)}
//                                             >
//                                                 <option value="USD">USD</option>
//                                                 <option value="EUR">EUR</option>
//                                                 <option value="GBP">GBP</option>
//                                             </select>
//                                         </div>

//                                         <div className={styles.formGroup}>
//                                             <label className={styles.formLabel}>Service Fee</label>
//                                             <input
//                                                 type="text"
//                                                 className={styles.formInput}
//                                                 value={newAssignment.service_fee}
//                                                 onChange={(e) => handleAssignmentChange('service_fee', Number(e.target.value))}
//                                                 placeholder="1500.00"
//                                             />
//                                         </div>

//                                         <div className={styles.formGroup}>
//                                             <label className={styles.formLabel}>Consent Template</label>
//                                             <select
//                                                 className={styles.formInput}
//                                                 value={newAssignment.consent_template}
//                                                 onChange={(e) => handleAssignmentChange('consent_template', e.target.value)}
//                                             >
//                                                 <option value="Template -1">Template -1</option>
//                                                 <option value="Template -2">Template -2</option>
//                                                 <option value="Template -3">Template -3</option>
//                                             </select>
//                                         </div>

//                                         <div className={styles.assignmentFormActions}>
//                                             <button
//                                                 type="button"
//                                                 className={styles.cancelAssignmentButton}
//                                                 onClick={handleCancelAssignment}
//                                             >
//                                                 Cancel
//                                             </button>
//                                             <button
//                                                 type="button"
//                                                 className={styles.saveAssignmentButton}
//                                                 onClick={handleSaveAssignment}
//                                             >
//                                                 {editingIndex !== null ? 'Update Assignment' : 'Save Assignment'}
//                                             </button>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {siteAssignments.length > 0 && (
//                                     <div className={styles.assignmentsTableWrapper}>
//                                         <table className={styles.assignmentsTable}>
//                                             <thead>
//                                                 <tr>
//                                                     <th>Study Details</th>
//                                                     <th>Site Details</th>
//                                                     <th>Max. Subjects</th>
//                                                     <th>Currency</th>
//                                                     <th>Service Fee</th>
//                                                     <th>Consent Template</th>
//                                                     <th>Actions</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {siteAssignments.map((assignment, index) => (
//                                                     <tr key={index}>
//                                                         <td>
//                                                             <div className={styles.tableText}>{assignment.study_number}</div>
//                                                             <div className={styles.tableSubtext}>{assignment.study_name}</div>
//                                                         </td>
//                                                         <td>
//                                                             <div className={styles.tableText}>{assignment.site_code}</div>
//                                                             <div className={styles.tableSubtext}>{assignment.site_name}</div>
//                                                         </td>
//                                                         <td>{assignment.max_subjects}</td>
//                                                         <td>{assignment.currency}</td>
//                                                         <td>{assignment.service_fee}</td>
//                                                         <td>{assignment.consent_template}</td>
//                                                         <td>
//                                                             <div className={styles.tableActions}>
//                                                                 <button
//                                                                     type="button"
//                                                                     className={styles.tableEditButton}
//                                                                     onClick={() => handleEditSite(index)}
//                                                                     title="Edit"
//                                                                 >
//                                                                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                                         <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                                                         <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                                                     </svg>
//                                                                 </button>
//                                                                 <button
//                                                                     type="button"
//                                                                     className={styles.tableDeleteButton}
//                                                                     onClick={() => handleRemoveSite(index)}
//                                                                     title="Delete"
//                                                                 >
//                                                                     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                                         <polyline points="3 6 5 6 21 6" />
//                                                                         <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
//                                                                     </svg>
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 )}
//                             </div>
//                         )}

//                         <div className={styles.formGroup}>
//                             <div className={styles.toggleContainer}>
//                                 <label className={styles.label}>Active</label>
//                                 <label className={styles.toggle}>
//                                     <input
//                                         type="checkbox"
//                                         checked={formData.status}
//                                         onChange={(e) => setFormData({ ...formData, status: e.target.checked })}
//                                     />
//                                     <span className={styles.toggleSlider}></span>
//                                 </label>
//                             </div>
//                         </div>
//                     </div>
//                     <div className={styles.sliderFooter}>
//                         <button type="button" className={styles.cancelButton} onClick={onClose}>Cancel</button>
//                         <button type="submit" className={styles.submitButton}>
//                             {mode === 'edit' ? 'Save Changes' : 'Create User'}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </>
//     );
// };

// export default UserFormSlider;

import React, { useState, useEffect } from 'react';
import styles from './UserManagement.module.css';

const UserFormSlider = ({
    show,
    mode,
    user,
    roles,
    studies,
    sites,
    consentTemplates,
    onClose,
    onSubmit
}) => {
    const [formData, setFormData] = useState({
        full_name: '',
        email_address: '',
        contact_number: '',
        role_id: '',
        study_id: '',
        site_id: '',
        assigned_sites: [],
        status: true
    });

    const [siteAssignments, setSiteAssignments] = useState([]);
    const [showAddAssignmentForm, setShowAddAssignmentForm] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [newAssignment, setNewAssignment] = useState({
        study_id: '',
        study_number: '',
        study_name: '',
        site_id: '',
        site_code: '',
        site_name: '',
        max_subjects: '20',
        currency: 'USD',
        service_fee: '',
        consent_template_id: '',
        consent_template: ''
    });

    useEffect(() => {
        if (mode === 'edit' && user) {
            setFormData({
                full_name: user.full_name,
                email_address: user.email_address,
                contact_number: user.contact_number || '',
                role_id: user.role_id || '',
                study_id: user.study_id || '',
                site_id: '',
                assigned_sites: user.assigned_sites || [],
                status: user.status === 'Active'
            });

            const mappedAssignments = (user.assigned_sites || []).map(assignment => {
                const study = studies.find(s => s.study_id === assignment.study_id);
                const site = sites.find(s => s.site_id === assignment.site_id);

                return {
                    study_id: assignment.study_id || '',
                    study_number: assignment.study_number || study?.study_number || '',
                    study_name: assignment.study_name || assignment.study_title || study?.study_title || '',
                    site_id: assignment.site_id || '',
                    site_code: assignment.site_code || site?.site_code || '',
                    site_name: assignment.site_name || site?.site_name || '',
                    max_subjects: assignment.max_subjects || '20',
                    currency: assignment.currency || 'USD',
                    service_fee: assignment.service_fee || '',
                    consent_template_id: assignment.consent_template_id || '',
                    consent_template: assignment.consent_template || ''
                };
            });

            setSiteAssignments(mappedAssignments);
        } else {
            setFormData({
                full_name: '',
                email_address: '',
                contact_number: '',
                role_id: '',
                study_id: '',
                site_id: '',
                assigned_sites: [],
                status: true
            });
            setSiteAssignments([]);
        }
        setShowAddAssignmentForm(false);
    }, [mode, user, show, studies, sites]);

    const handleAddSite = () => {
        setShowAddAssignmentForm(true);
        setEditingIndex(null);
        setNewAssignment({
            study_id: '',
            study_number: '',
            study_name: '',
            site_id: '',
            site_code: '',
            site_name: '',
            max_subjects: '20',
            currency: 'USD',
            service_fee: '',
            consent_template_id: '',
            consent_template: ''
        });
    };

    const handleEditSite = (index) => {
        setShowAddAssignmentForm(true);
        setEditingIndex(index);
        setNewAssignment({ ...siteAssignments[index] });
    };

    const handleRemoveSite = (index) => {
        const newAssignments = siteAssignments.filter((_, i) => i !== index);
        setSiteAssignments(newAssignments);
    };

    const handleAssignmentChange = (field, value) => {
        setNewAssignment(prev => ({ ...prev, [field]: value }));

        if (field === 'site_id') {
            const selectedSite = sites.find(site => site.site_id === value);
            if (selectedSite) {
                setNewAssignment(prev => ({
                    ...prev,
                    site_code: selectedSite.site_code,
                    site_name: selectedSite.site_name
                }));
            }
        }

        if (field === 'study_id') {
            const selectedStudy = studies.find(study => study.study_id === value);
            if (selectedStudy) {
                setNewAssignment(prev => ({
                    ...prev,
                    study_number: selectedStudy.study_number,
                    study_name: selectedStudy.study_title
                }));
            }
        }

        if (field === 'consent_template_id') {
            const selectedTemplate = consentTemplates.find(template => template.id === parseInt(value));
            if (selectedTemplate) {
                setNewAssignment(prev => ({
                    ...prev,
                    consent_template_id: value,
                    consent_template: selectedTemplate.title,
                    service_fee: selectedTemplate.service_fee.toString()
                }));
            }
        }
    };

    const handleSaveAssignment = () => {
        if (newAssignment.study_id && newAssignment.site_id) {
            if (editingIndex !== null) {
                const updatedAssignments = [...siteAssignments];
                updatedAssignments[editingIndex] = { ...newAssignment };
                setSiteAssignments(updatedAssignments);
            } else {
                setSiteAssignments([...siteAssignments, { ...newAssignment }]);
            }
            setShowAddAssignmentForm(false);
            setEditingIndex(null);
            setNewAssignment({
                study_id: '',
                study_number: '',
                study_name: '',
                site_id: '',
                site_code: '',
                site_name: '',
                max_subjects: '20',
                currency: 'USD',
                service_fee: '',
                consent_template_id: '',
                consent_template: ''
            });
        }
    };

    const handleCancelAssignment = () => {
        setShowAddAssignmentForm(false);
        setEditingIndex(null);
        setNewAssignment({
            study_id: '',
            study_number: '',
            study_name: '',
            site_id: '',
            site_code: '',
            site_name: '',
            max_subjects: '20',
            currency: 'USD',
            service_fee: '',
            consent_template_id: '',
            consent_template: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const submitData = {
            ...formData,
            assigned_sites: siteAssignments,
            status: formData.status ? 'Active' : 'Inactive'
        };

        const result = mode === 'edit'
            ? await onSubmit(user.user_id, submitData)
            : await onSubmit(submitData);

        if (result.success) {
            onClose();
        }
    };

    if (!show) return null;

    const selectedRole = roles.find(role => String(role.role_id) === String(formData.role_id));
    const isPrincipalInvestigator = selectedRole && (
        selectedRole.role_name === 'Principal Investigator' ||
        String(selectedRole.role_id) === '2'
    );

    return (
        <>
            <div className={styles.sliderOverlay} onClick={onClose}></div>
            <div className={`${styles.slider} ${show ? styles.sliderOpen : ''}`}>
                <div className={styles.sliderHeader}>
                    <h2 className={styles.sliderTitle}>{mode === 'edit' ? 'Edit User' : 'Create New User'}</h2>
                    <button className={styles.sliderClose} onClick={onClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.sliderBody}>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Full Name *</label>
                            <input
                                type="text"
                                className={styles.input}
                                required
                                value={formData.full_name}
                                onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                                placeholder="Enter full name"
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Email Address *</label>
                            <input
                                type="email"
                                className={styles.input}
                                required
                                value={formData.email_address}
                                onChange={(e) => setFormData({ ...formData, email_address: e.target.value })}
                                placeholder="user@example.com"
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Contact Number *</label>
                            <input
                                type="text"
                                className={styles.input}
                                required
                                value={formData.contact_number}
                                onChange={(e) => setFormData({ ...formData, contact_number: e.target.value })}
                                placeholder="+1234567890"
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label className={styles.label}>Role *</label>
                            <select
                                className={styles.input}
                                required
                                value={formData.role_id}
                                onChange={(e) => setFormData({ ...formData, role_id: e.target.value })}
                            >
                                <option value="">Select Role</option>
                                {roles.map((role) => (
                                    <option key={role.role_id} value={role.role_id}>{role.role_name}</option>
                                ))}
                            </select>
                        </div>

                        {isPrincipalInvestigator && (
                            <div className={styles.siteAssignmentsSection}>
                                <label className={styles.label}>Study & Site Assignments</label>

                                {!showAddAssignmentForm && (
                                    <button
                                        type="button"
                                        className={styles.addAssignmentLink}
                                        onClick={handleAddSite}
                                    >
                                        <span className={styles.addIcon}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <circle cx="12" cy="12" r="10" />
                                                <line x1="12" y1="8" x2="12" y2="16" />
                                                <line x1="8" y1="12" x2="16" y2="12" />
                                            </svg>
                                        </span>
                                        Add a site assignment
                                    </button>
                                )}

                                {showAddAssignmentForm && (
                                    <div className={styles.assignmentForm}>
                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Study *</label>
                                            <select
                                                className={styles.formInput}
                                                value={newAssignment.study_id}
                                                onChange={(e) => handleAssignmentChange('study_id', e.target.value)}
                                                required
                                            >
                                                <option value="">Select Study</option>
                                                {studies.map((study) => (
                                                    <option key={study.study_id} value={study.study_id}>
                                                        {study.study_number} - {study.study_title}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Site *</label>
                                            <select
                                                className={styles.formInput}
                                                value={newAssignment.site_id}
                                                onChange={(e) => handleAssignmentChange('site_id', e.target.value)}
                                                required
                                            >
                                                <option value="">Select Site</option>
                                                {sites.map((site) => (
                                                    <option key={site.site_id} value={site.site_id}>
                                                        {site.site_code} - {site.site_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Max. Subjects</label>
                                            <select
                                                className={styles.formInput}
                                                value={newAssignment.max_subjects}
                                                onChange={(e) => handleAssignmentChange('max_subjects', e.target.value)}
                                            >
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>

                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Currency</label>
                                            <select
                                                className={styles.formInput}
                                                value={newAssignment.currency}
                                                onChange={(e) => handleAssignmentChange('currency', e.target.value)}
                                            >
                                                <option value="USD">USD</option>
                                                <option value="EUR">EUR</option>
                                                <option value="GBP">GBP</option>
                                            </select>
                                        </div>

                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Consent Template *</label>
                                            <select
                                                className={styles.formInput}
                                                value={newAssignment.consent_template_id}
                                                onChange={(e) => handleAssignmentChange('consent_template_id', e.target.value)}
                                                required
                                            >
                                                <option value="">Select Template</option>
                                                {consentTemplates.map((template) => (
                                                    <option key={template.id} value={template.id}>
                                                        {template.title}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className={styles.formGroup}>
                                            <label className={styles.formLabel}>Service Fee</label>
                                            <input
                                                type="text"
                                                className={styles.formInput}
                                                value={newAssignment.service_fee}
                                                onChange={(e) => handleAssignmentChange('service_fee', e.target.value)}
                                                placeholder="Auto-filled from template"
                                                readOnly
                                            />
                                        </div>

                                        <div className={styles.assignmentFormActions}>
                                            <button
                                                type="button"
                                                className={styles.cancelAssignmentButton}
                                                onClick={handleCancelAssignment}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className={styles.saveAssignmentButton}
                                                onClick={handleSaveAssignment}
                                            >
                                                {editingIndex !== null ? 'Update Assignment' : 'Save Assignment'}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {siteAssignments.length > 0 && (
                                    <div className={styles.assignmentsTableWrapper}>
                                        <table className={styles.assignmentsTable}>
                                            <thead>
                                                <tr>
                                                    <th>Study Details</th>
                                                    <th>Site Details</th>
                                                    <th>Max. Subjects</th>
                                                    <th>Currency</th>
                                                    <th>Service Fee</th>
                                                    <th>Consent Template</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {siteAssignments.map((assignment, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className={styles.tableText}>{assignment.study_number}</div>
                                                            <div className={styles.tableSubtext}>{assignment.study_name}</div>
                                                        </td>
                                                        <td>
                                                            <div className={styles.tableText}>{assignment.site_code}</div>
                                                            <div className={styles.tableSubtext}>{assignment.site_name}</div>
                                                        </td>
                                                        <td>{assignment.max_subjects}</td>
                                                        <td>{assignment.currency}</td>
                                                        <td>{assignment.service_fee}</td>
                                                        <td>{assignment.consent_template}</td>
                                                        <td>
                                                            <div className={styles.tableActions}>
                                                                <button
                                                                    type="button"
                                                                    className={styles.tableEditButton}
                                                                    onClick={() => handleEditSite(index)}
                                                                    title="Edit"
                                                                >
                                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                                                    </svg>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className={styles.tableDeleteButton}
                                                                    onClick={() => handleRemoveSite(index)}
                                                                    title="Delete"
                                                                >
                                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                        <polyline points="3 6 5 6 21 6" />
                                                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className={styles.formGroup}>
                            <div className={styles.toggleContainer}>
                                <label className={styles.label}>Active</label>
                                <label className={styles.toggle}>
                                    <input
                                        type="checkbox"
                                        checked={formData.status}
                                        onChange={(e) => setFormData({ ...formData, status: e.target.checked })}
                                    />
                                    <span className={styles.toggleSlider}></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className={styles.sliderFooter}>
                        <button type="button" className={styles.cancelButton} onClick={onClose}>Cancel</button>
                        <button type="submit" className={styles.submitButton}>
                            {mode === 'edit' ? 'Save Changes' : 'Create User'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default UserFormSlider;